import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_announce_red.svg'
import _imports_1 from '@/app/ui/assets/svg/frame-image.svg'


const _hoisted_1 = { class: "grid grid-rows-[auto_1fr]" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center gap-2 mb-4 p-4 border-b border-gray-lp-1400" }, [
  /*#__PURE__*/_createVNode("div", { class: "p-2 rounded-lg border border-red-lp-100 bg-red-lp-50" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "w-5"
    })
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("p", { class: "text-black-lp-300 text-base font-bold" }, " Bingung cara lapor? Baca panduan yuk! "),
    /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-600 text-sm" }, " Pastikan jenis & kategori sesuai kendala Anda. ")
  ])
], -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-8 place-items-center p-4 bg-gray-lp-100 rounded-lg" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "pl-6 pr-16 pb-6" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-1400 my-3" }, null, -1)
const _hoisted_10 = { class: "text-gray-lp-600 text-xs mb-4" }
const _hoisted_11 = { class: "text-gray-lp-300 text-xs font-semibold mb-2 list-disc" }
const _hoisted_12 = { class: " pl-5 text-gray-lp-600 text-xs space-y-1" }
const _hoisted_13 = { class: "text-gray-lp-600 flex items-center gap-2 list-disc mb-1 " }
const _hoisted_14 = { class: "list-disc pl-4" }
const _hoisted_15 = { class: "text-black-lp-300 text-xs font-semibold mb-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Panduan lampiran file: ")
const _hoisted_17 = { class: "space-y-3 mx-5" }
const _hoisted_18 = { class: "font-semibold text-xs text-white px-6 pt-4 pb-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("hr", { class: "border border-gray-lp-200 mx-6 opacity-50 " }, null, -1)
const _hoisted_20 = { class: "flex flex-row justify-between items-start gap-4 px-6 py-4" }
const _hoisted_21 = { class: "text-white text-10px font-medium max-w-200px flex-1" }
const _hoisted_22 = { class: "relative h-28" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute inset-0 w-full p-2",
  alt: "frame"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute bottom-0 w-full p-2",
  style: {"transform":"rotate(180deg)"},
  alt: "frame"
}, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "space-y-4" }
const _hoisted_27 = { class: "flex flex-col gap-2" }
const _hoisted_28 = { class: "pl-6 pr-16 pb-6" }
const _hoisted_29 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-1400 my-3" }, null, -1)
const _hoisted_30 = { class: "text-gray-lp-600 text-xs mb-4" }
const _hoisted_31 = { class: "text-gray-lp-300 text-xs font-semibold mb-2 list-disc" }
const _hoisted_32 = { class: " pl-5 text-gray-lp-600 text-xs space-y-1" }
const _hoisted_33 = { class: "text-gray-lp-600 flex items-center gap-2 list-disc mb-1" }
const _hoisted_34 = { class: "list-disc pl-4" }
const _hoisted_35 = { class: "text-black-lp-300 text-xs font-semibold mb-3" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Panduan lampiran file: ")
const _hoisted_37 = { class: "space-y-3 mx-5" }
const _hoisted_38 = { class: "font-semibold text-xs text-white px-6 pt-4 pb-2" }
const _hoisted_39 = /*#__PURE__*/_createVNode("hr", { class: "border border-gray-lp-200 mx-6 opacity-50" }, null, -1)
const _hoisted_40 = { class: "flex flex-row items-start justify-between px-6 py-4" }
const _hoisted_41 = { class: "text-white text-10px font-medium max-w-200px flex-1" }
const _hoisted_42 = { class: "relative h-28" }
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute inset-0 w-full p-2",
  alt: "frame"
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "absolute bottom-0 w-full p-2",
  style: {"transform":"rotate(180deg)"},
  alt: "frame"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_GuideCarouselModal = _resolveComponent("GuideCarouselModal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: ["py-3 px-2 w-full text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-300 bg-white font-semibold shadow rounded-lg':
            _ctx.activeTab === 'shipping',
          'text-gray-lp-2600 font-semibold': _ctx.activeTab !== 'shipping'
        }],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'shipping'))
      }, " Pengiriman & bantuan ", 2),
      _createVNode("div", {
        class: ["py-3 px-2 w-full whitespace-nowrap text-sm focus:outline-none transition-colors duration-200 cursor-pointer text-center", {
          'text-black-lp-300 bg-white font-medium shadow rounded-lg':
            _ctx.activeTab === 'system',
          'text-gray-lp-2600': _ctx.activeTab !== 'system'
        }],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'system'))
      }, " Sistem & banding pinalti ", 2)
    ]),
    _createVNode("div", _hoisted_4, [
      (_ctx.activeTab === 'shipping')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentGuideList, (guide, index) => {
                  return (_openBlock(), _createBlock(_component_Accordion, {
                    key: index,
                    label: guide.title,
                    class: "shadow text-sm mb-2 text-gray-lp-300 border-none rounded-lg",
                    borderHeader: "border-none",
                    chevrons: ['chevron-up', 'chevron-down'],
                    titleFontWeight: "font-bold"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("div", null, [
                          _createVNode("p", _hoisted_10, _toDisplayString(guide.content), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.status, (status, statusIndex) => {
                            return _withDirectives((_openBlock(), _createBlock("div", {
                              class: "mb-4",
                              key: statusIndex
                            }, [
                              _createVNode("li", _hoisted_11, _toDisplayString(status.title), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.list, (listStatus, index) => {
                                return (_openBlock(), _createBlock("div", { key: index }, [
                                  _createVNode("ul", _hoisted_12, [
                                    _createVNode("li", _hoisted_13, _toDisplayString(listStatus), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 512)), [
                              [_vShow, status.list.length > 0]
                            ])
                          }), 128)),
                          _createVNode("ul", _hoisted_14, [
                            _createVNode("li", _hoisted_15, [
                              _hoisted_16,
                              _createVNode("span", {
                                class: "text-red-lp-100 border-b border-red-lp-100 cursor-pointer text-xs font-semibold",
                                onClick: ($event: any) => (_ctx.openCarousel(guide))
                              }, "Lihat detail", 8, ["onClick"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_17, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.carousel_list, (carousel, carouselIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: carouselIndex,
                                class: "bg-blue-lp-100 rounded-lg overflow-hidden"
                              }, [
                                _createVNode("p", _hoisted_18, _toDisplayString(carousel.title), 1),
                                _hoisted_19,
                                _createVNode("div", _hoisted_20, [
                                  _createVNode("p", _hoisted_21, _toDisplayString(carousel.description), 1),
                                  _createVNode("div", _hoisted_22, [
                                    _createVNode("img", {
                                      src: carousel.image_url,
                                      class: "w-36 h-28 rounded-lg object-contain",
                                      alt: "image_lampiran"
                                    }, null, 8, ["src"]),
                                    _hoisted_23,
                                    _hoisted_24
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'system')
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contentGuideListSystem, (guide, index) => {
                  return (_openBlock(), _createBlock(_component_Accordion, {
                    key: index,
                    label: guide.title,
                    class: "shadow text-sm mb-2 text-gray-lp-300 border-none rounded-lg",
                    borderHeader: "border-none",
                    chevrons: ['chevron-up', 'chevron-down'],
                    titleFontWeight: "font-bold"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("div", null, [
                          _createVNode("p", _hoisted_30, _toDisplayString(guide.content), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.status, (status, statusIndex) => {
                            return _withDirectives((_openBlock(), _createBlock("div", {
                              class: "mb-4",
                              key: statusIndex
                            }, [
                              _createVNode("li", _hoisted_31, _toDisplayString(status.title), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.list, (listStatus, index) => {
                                return (_openBlock(), _createBlock("div", { key: index }, [
                                  _createVNode("ul", _hoisted_32, [
                                    _createVNode("li", _hoisted_33, _toDisplayString(listStatus), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 512)), [
                              [_vShow, status.list.length > 0]
                            ])
                          }), 128)),
                          _createVNode("ul", _hoisted_34, [
                            _createVNode("li", _hoisted_35, [
                              _hoisted_36,
                              _createVNode("span", {
                                class: "text-red-lp-100 border-b border-red-lp-100 cursor-pointer text-xs font-semibold",
                                onClick: ($event: any) => (_ctx.openCarousel(guide))
                              }, "Lihat detail", 8, ["onClick"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_37, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(guide.carousel_list, (carousel, carouselIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: carouselIndex,
                                class: "bg-blue-lp-100 rounded-lg overflow-hidden"
                              }, [
                                _createVNode("p", _hoisted_38, _toDisplayString(carousel.title), 1),
                                _hoisted_39,
                                _createVNode("div", _hoisted_40, [
                                  _createVNode("p", _hoisted_41, _toDisplayString(carousel.description), 1),
                                  _createVNode("div", _hoisted_42, [
                                    _createVNode("img", {
                                      src: carousel.image_url,
                                      class: "w-36 h-28 rounded-lg object-contain",
                                      alt: "image_lampiran"
                                    }, null, 8, ["src"]),
                                    _hoisted_43,
                                    _hoisted_44
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_GuideCarouselModal, {
      show: _ctx.showCarousel,
      guide: _ctx.selectedGuide,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCarousel = $event))
    }, null, 8, ["show", "guide"])
  ]))
}